"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
export default function Showcase() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="interiorshowcase" data-nav="light" className="w-full bg-background px-4 py-8 sm:px-8 md:px-12 md:py-16 lg:px-16">
      <div className="mx-auto max-w-7xl">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        scale: 1
      } : {
        opacity: 0.85,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1]
      }} className="relative w-full overflow-hidden">
          <div className="relative aspect-4/3 w-full sm:aspect-16/10 lg:aspect-21/11">
            <img data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1781435/img/curated_study_interior.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1781435/img/curated_study_interior.png-wvc-sizes" alt="Curated studio study interior featuring bespoke wooden desk, statement chandelier, stone fireplace, and contemporary artwork" loading="lazy" decoding="async" className="h-full w-full object-cover object-center grayscale" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1781435/img/home.jpg" />
          </div>
        </motion.div>
      </div>
    </section>;
}